export default __webpack_public_path__ + "static/beneficios-medioambiente-ed70e39e294fea71abfec9b14a7e336d.png";